export default __webpack_public_path__ + "static/media/onto-1.e7bbae5a.png";